import React, { useState, useMemo } from 'react';
import './style.scss';

import Btn from "../../../Btn";
import PropTypes from "prop-types";

const education = [
    {
        iconName:    ['postbox'],
        title:       'Беріть участь у голосуванні',
        description: 'Ви можете повернутися на сторінку в будь-який час протягом голосування і віддати невикористані голоси',
    },
    {
        iconName:    ['people_check', 'people_check'],
        title:       'Ви можете проголосувати за двох кандидатів',
        description: 'Ви можете повернутися на сторінку в будь-який час протягом голосування і віддати невикористані голоси',
    },
    {
        iconName:    ['time'],
        title:       'Голосування обмежене за часом',
        description: 'Ви можете повернутися на сторінку в будь-який час протягом голосування і віддати невикористані голоси',
    },
    {
        iconName:    ['check_squareN', 'arrow_right', 'check_square_fillN'],
        title:       'Щоб проголосувати, натисніть характерну кнопку',
        description: 'Ви можете повернутися на сторінку в будь-який час протягом голосування і віддати невикористані голоси',
    }
];

export const FirstSession = ({ onClose, onGotIt }) => {

    const [activeScreen, setActiveScreen] = useState(0);
    const limitScreen = education.length-1;

    const onNext = () => {
        if (activeScreen < limitScreen) {
            setActiveScreen((prevState) => prevState + 1);
        } else {
            onGotIt();
        }
    };

    const renderPag = useMemo(() => {
        const paginatation = [];

        for (let i = 0; i <= limitScreen; i++) {
            paginatation.push(
                <span
                    className = { `pagination__item ${activeScreen === i ? 'pagination__item--active' : ''}` }
                    key = { i }
                />
            );
        }

        return (
            <div className = 'pagination' >
                {paginatation}
            </div>
        );
    }, [activeScreen]);

    const renderScreens = useMemo(() => {

        return education.map((item, index) => {
            return (
                <div
                    className = { `education__screen ${index === activeScreen ? 'education__screen--active' : ''} ` }
                    key = { item.title }>
                    <div className = 'education__icons'>
                        {item.iconName.map((name, index) => (
                            <i
                                className = { `education__icon icon icon-${name} ${name==='arrow_right' ? 'education__icon--center' : ''}` }
                                key = { index }
                            />
                        ))}
                    </div>
                    <h3 className = 'education__title'>{item.title}</h3>
                    <p className = 'education__description'>
                        {item.description}
                    </p>
                </div>
            );
        });
    }, [activeScreen]);

    return (

        <div className = 'education'>

            <div className = 'education__wrap'>
                {renderScreens}
            </div>

            <div className = { 'education__btn-wrap' }>
                <Btn
                    full
                    theme = 'black'
                    title = { activeScreen === limitScreen ? 'Зрозуміло' : 'Далі' }
                    onPress = { onNext }
                />
                {renderPag}
            </div>
        </div>

    );
};

FirstSession.propTypes = {
    onClose: PropTypes.func.isRequired,
    onGotIt: PropTypes.func.isRequired,
};
